module.exports = __webpack_public_path__ + "static/tip_3-70d3133cb99b14cae80572b7d5f35a8e.jpg";